/* eslint-disable no-unused-vars */
import { Badge, Box, Flex, Heading, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import linelist from "../../media/directoryReport.png";
import file from "../../media/fileTypeImg.png";
import pbi from "../../media/PowerBi.png";
import staticImg from "../../media/staticReport.png";
import tableau from "../../media/Tableau.png";
import isTableauAvailable from "../../utils/isTableauAvailable";
import PowerBi from "../ReportsComponents/PowerBI/PowerBi";
import StaticImage from "../ReportsComponents/StaticImage/StaticImage";
import TableauEmbed from "../ReportsComponents/Tableau/TableauEmbed";
import TableauNotAvailableThisTime from "../ReportsComponents/Tableau/TableauNotAvailableThisTime";
import DirectoryCards from "./DirectoryCards";
const ContentPanel = ({ content, onBack }) => {
  const [isAvailable, setIsAvailable] = useState(false);

  useEffect(() => {
    const available = isTableauAvailable();
    if (available) {
      setIsAvailable(true);
    }
  }, []);
  const IMAGE_ASSETS = {
    pbi,
    linelist,
    staticImg,
    tableau,
    file,
  };

  // Helper function to get the correct image source
  const getImageSource = (cardImg) => {
    if (!cardImg) return staticImg;
    if (cardImg.includes("://")) return cardImg;
    return IMAGE_ASSETS[cardImg] || staticImg;
  };
  const imageSrc = getImageSource(content?.cardImg);
  if (!content) {
    return (
      <Box
        flex="1"
        // overflowY="auto"
        // height="calc(100vh - 60px)"
        px={8}
        py={8}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text fontSize="lg" color="gray.500">
          Select a topic from the sidebar to view its content
        </Text>
      </Box>
    );
  }

  const renderComponentByType = (type, data) => {
    switch (type) {
      case "tableau":
        return (
          <>
            {isAvailable ? (
              <TableauEmbed embedData={data} />
            ) : (
              <TableauNotAvailableThisTime />
            )}
          </>
        );
      case "powerbi":
        return <PowerBi key={data.id} powerBiData={data} />;
      case "directory":
      case "file":
        return <DirectoryCards data={data} />;
      default:
        return <StaticImage imageData={data} />;
    }
  };

  // Color scheme based on type
  const typeColors = {
    powerbi: "purple",
    tableau: "orange",
    file: "teal",
    directory: "blue",
    static: "gray",
  };

  const badgeColor = typeColors[content.type] || "gray";

  return (
    <Box flex="1" px={8} py={5}>
      <Box mb={2}>
        {/* Title */}
        <Flex alignItems="center" gap={5}>
          <FaArrowLeft size={25} cursor="pointer" onClick={onBack} />
          <Heading as="h1" size="xl" color="teal.700" fontWeight="bold">
            {content.title}
            <Badge
              colorScheme={badgeColor}
              fontSize="xs"
              textTransform="uppercase"
              ml={1}
            >
              {content.type === "directory" ? "Folder" : content.type}
            </Badge>
          </Heading>
        </Flex>
      </Box>

      {renderComponentByType(content.type, content)}
      {/* Main Description */}
      <VStack align="stretch" spacing={4}>
        <Text fontSize="md" lineHeight="tall" color="gray.700" my={5}>
          {content.desc}
        </Text>

        {/* Dynamic Sections */}
        {/* Featured Image */}
        {/* {content.cardImg && (
          <Image
            src={imageSrc}
            alt={content.title}
            borderRadius="md"
            mb={1}
            w="100%"
            objectFit="cover"
            maxH="420px"
            boxShadow="md"
          />
        )} */}

        {/* Additional spacing at bottom for better scrolling experience */}
        <Box h={8} />
      </VStack>
    </Box>
  );
};

export default ContentPanel;
